import { render, staticRenderFns } from "./SingleSelect.vue?vue&type=template&id=70463723&scoped=true&"
import script from "./SingleSelect.vue?vue&type=script&lang=js&"
export * from "./SingleSelect.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelect.vue?vue&type=style&index=0&id=70463723&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70463723",
  null
  
)

export default component.exports